import { toRem } from '@marriott/shared/mi-helper-utils';
import styled from 'styled-components';

interface ColumnProps {
  align: 'left' | 'right';
}

// const { spacers } = baseVariables;
// TODO: Remove this spacers stub once we can import from mi-ui-library
const spacers = {
  spacers: {
    0: '0',
    1: '0.25rem',
    2: '0.5rem',
    3: '1rem',
    4: '1.5rem',
    5: '2rem',
  },
};

export const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  column-gap: ${spacers?.spacers?.[3] ?? '1rem'};
`;

export const Column = styled.div<ColumnProps>`
  text-align: ${({ align }) => (align === 'left' ? 'left' : 'right')};
  width: 50%;

  &:first-child {
    min-width: ${toRem(200)};
    max-width: 50%;
  }
`;
